export default __webpack_public_path__ + "static/media/rat.a06272d9.png";